import FacebookIcon from "@mui/icons-material/Facebook";
import TwitterIcon from "@mui/icons-material/Twitter";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import ResearchGateIcon from "@mui/icons-material/Article";
import MKTypography from "components/MKTypography";
import logoCT from "assets/images/logo-ct-dark.png"; 

const date = new Date().getFullYear();

export default {
  brand: {
    name: "RO Informational",
    image :logoCT,
    route: "/",
  },
  socials: [
    {
      icon: <FacebookIcon />,
      link: "",
    },
    {
      icon: <TwitterIcon />,
      link: "",
    },
    {
      icon: <LinkedInIcon />,
      link: "",
    },
    {
      icon: <ResearchGateIcon />,
      link: "",
    },
  ],
  menus: [
    {
      name: "Research",
      items: [
        { name: "Our Focus Areas", href: "" },
        { name: "Publications", href: "" },
        { name: "Ongoing Projects", href: "" },
        { name: "Research Impact", href: "" },
      ],
    },
    {
      name: "Resources",
      items: [
        { name: "Data Repository", href: "" },
        { name: "Research Tools", href: "" },
        { name: "Funding Opportunities", href: "" },
      ],
    },
    {
      name: "About Us",
      items: [
        { name: "Our Team", href: "" },
        { name: "Partnerships", href: "" },
        { name: "Careers", href: "" },
        { name: "Contact Us", href: "" },
      ],
    },
    {
      name: "Policies",
      items: [
        { name: "Ethics Guidelines", href: "" },
        { name: "Privacy Policy", href: "" },
        { name: "Open Access Policy", href: "" },
      ],
    },
  ],
  copyright: (
    <MKTypography variant="button" fontWeight="regular">
      All rights reserved. Copyright &copy; {date} RO Informational.{" "}
      <MKTypography
        component="a"
        href=""
        target="_blank"
        rel="noreferrer"
        variant="button"
        fontWeight="regular"
      >
        Learn more about our work
      </MKTypography>
      .
    </MKTypography>
  ),
};